/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/session/login',
    name: 'Login',
    view: 'Login'
  },

  {
    path: '/session/forget-password',
    name: 'Forget Password',
    view: 'ForgetPassword',
  },
  {
    path: '/session/reset-password/:token',
    name: 'Reset Password',
    view: 'ResetPassword',
  },
  {
    path: '/list',
    name: 'Posts',
    view: 'List',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/dashboard-2021',
    name: 'Result Summary',
    view: 'BarChart',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard-2020',
    name: 'Result Summary',
    view: 'AreaChart',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/average-verification-time',
    name: 'Average Verification Time',
    view: 'AverageVerificationTimeChart',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fake-vs-genuine',
    name: 'FakeVSGenuine',
    view: 'FakeVSGenuine',
    meta: {
      requiresAuth: true
    }
  },{
    path: '/unsure-results-graph',
    name: 'UnsureResults',
    view: 'UnsureResultsGraph',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/scans-over-time-graph',
    name: 'ScansOverTime',
    view: 'ScansOverTime',
    meta: {
      requiresAuth: true
    }
  },{
    path: '/percentage-of-attempts',
    name: 'PercentageOfAttempts',
    view: 'PercentageOfAttempts',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-search',
    name: 'UserSearchByCode',
    view: 'UserSearchByCode',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/image-search',
    name: 'ImageSearchByCode',
    view: 'ImageSearchByCode',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/graph-list',
    name: 'GraphList',
    view: 'GraphList',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    view: 'UsersList',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-user',
    name: 'Add User',
    view: 'AddUser',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/certificates-scanned',
    name: 'Certificates Scanned',
    view: 'CertificateScanned',
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/dashboard-2021',
    name: 'Result Summary',
    view: 'AverageVerification',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add',
    name: 'Add Post',
    view: 'AddEdit',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/edit/:id?',
    name: 'Edit Post',
    view: 'AddEdit',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/activity',
    name: 'Activity Log',
    view: 'ActivityLog',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/graphs',
    name: 'Graphs',
    view: 'Graphs',
    meta: {
      requiresAuth: true
    }

  },
  {
    path: '/change-password',
    name: 'Change Password',
    view: 'ChangePassword',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/clients',
    name: 'Client List',
    view: 'Clients',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    view: 'IframeDashboard',
    meta: {
      requiresAuth: true
    }
  }

]
